const RESET_SESSION = `RESET_SESSION`;

const resetSession = (loggedIn) => ({
  type: RESET_SESSION,
  loggedIn,
});

export {
  RESET_SESSION,
  resetSession,
};
